import { VueModule } from '@Foundation';
import ArticleHighlightPush from './code/Scripts/components/article-highlight-push';

export default VueModule({
  components: {
    ArticleHighlightPush
  }
});
